export default "__VITE_ASSET__DBtrC5Yw__ 640w, __VITE_ASSET__DtYWkUTM__ 1024w";